export const alertPageError = {
    Close: "No thanks",
    Notclose: "Yes"
}

export const changePasswordErrorMessage = {
    OldPasswordRequired: "Old password is required.",
    NewPasswordRequired: "New password is required.",
    PasswordPattern: "Passwords must be at least 6 characters long, contain at least one number, and have a mixture of uppercase and lowercase letters.",
    ConfirmNewPassword: "Confirm password required."
}

export const commonErrorMessage = {
    FirstNameIsRequired: "First name is required.",
    LastNameIsRequired: "Last name is required.",
    EmailIdIsRequired: "Email id is required.",
    EmailIsInvalid: "Email is invalid.",
    MobileNumberIsRequired: "Mobile number is required.",
    MobileaNumberIsInvalid: "Mobile number is invalid.",
    AddressIsRequired: "Address is required.",
    InvalidWebsiteFormat: "Invalid website format.",
    RoleNameIsRequired: "Role name is required.",
    ConfirmationForLogout: "Are you sure to logout ?",
    FileIsRequired: "File is required.",
    NoResultFound: "No result found.",
    Max100Limit: " Maximum 100 characters.",
    StateNameIsRequired: "State name is required.",
    StateMaxLimit100: " State name does not have more than 100 characters.",
    CityNameIsRequired: " City name is required.",
    CityMaxLimit100: "City name does not have more than 100 characters.",
    MobileNumberMinLimit: "Please enter 10 digit mobile number.",
    MobileNumberValidPhoneNumber: "Please enter valid mobile number.",
}

export const companyErrorPageMessage = {
    CompanyNameRequired: "Company name is required.",
    CompanyAddressRequired: "Company address is required.",
    CompanyAboutIsRequired: "Company about is required.",
    CompanyIndustryIsRequired: "Company industry  is required.",
    CompanySizeFormat: "Company size is invalid.",
    CompanySizeIsRequired: " Company size is required.",
    CompanyWebsiteIsRequired: "Company website is required."
}

export const collegeErrorPageMessage = {
    CollegeNameIsRequired: "College name is required.",
    BatchIsRequired: "Batch is required.",
    CollegeNameLimit100: "College name does not have more than 100 characters.",
    BatchYearIsRequired: "Batch  year is required.",
    BatchYearRange: "  Batch year should be between 2020 and 2099.",

}
export const technologyErrorPageMessage = {
    ParentTechnologyIsRequired: "Parent technology name is required.",
    ParentTechnologyLogoIsRequired: "Parent technology logo is required.",
    ChildTechnolgyIsRequired: "Child technology name is required.",
    ParentTechnologyNameLimit100: "Parent technology name does not have more than 100 characters.",
    ChildTechnologyNameLimit100: "Child technology name does not have more than 100 characters.",
    SelectParentTechnology: "Please select parent technology.",
}

export const notFoundPageError = {
    PageNotFound: "Opps! page not found",
    SorryForInconvinentMessage: "We're sorry, the page you requested cannot be found.",
    GoBack: "You can go back to",

}

export const questionErrorPageMessage = {
    QuestionHaveAtleast2Length: "The Question must have at least 2 options.",
    QuestionImageIsRequired: " Question image is required.",
    QuestionSetIsRequired: " Question set is required.",
    QuestionIsRequired: " Question is required.",
    QuestionLengthLimit: "Question text limit reached.",
    QuestionSetNameIsRequired: "Question set name is required.",
    QuestionStringLimit: "Question set only allows 100 characters.",
    QuestionMustHaveDifferentOption: "The question must have different options.",
    QuestionMustHaveAtleast1CorrectAnswer: "The question must have at least 1 correct answer.",
    QuestionMustHaveAtleast2CorrectAnswer: "The question must have at least 2 correct answer.",
    QuestionParagraphIsRequired: "Paragraph is required.",
}

export const studentErrorPageMessage = {
    StudentNameIsRequired: "Student name is required.",
    StudentNameLimit100: " Student name does not have more than 100 characters.",
}

export const JobErrorPageMessage = {
    TitleIsRequired: "Title is required.",
    TitleLengthValidation: "Maximum characters should not be more than 40.", 
    StateIsRequired: "State is required.",
    CityIsRequired: " City is required.",
    TagIsRequired: "Tags is required.",
    TechnologyIsRequired: "Technology is required.",
    VacanciesIsRequired: "No of vacancies is required.",
    ValidVacanciesNumber: "Please enter valid number.",
    MinExperienceIsRequired: "Min experience is required.",
    MinExperienceValueLessThanEqualTo: "Min experience must be less than or equal to 100.",
    MinExperienceValueGreaterThanZero: "Min experience must be greater than 0.",
    VacancyValueGreaterThanZero: "Vacancy must be greater than 0.",
    MaxOneDecimalAllowed:"Maximum of one decimal places allowed.",
    MinSalaryIsRequired: "Minimum salary is required.",
    SalaryValueGreaterThanZero: "Salary must be greater than 0.",
    ValueLessThanEqualTo:" Value must be less than or equal to 1,000,000,000.",
    MaxTwoDecimalAllowed:"Maximum of two decimal places allowed.",
    MaxSalaryIsRequired:"Maximum salary is required.",
    MaxSalaryIsNotLessThanMinSalary:"Maximum salary should not be less than or equal to minimum salary.",
    JobDescriptionIsRequired: "Job description is required.",
    ResponsblitiesIsRequired: "Responsibilities is required.",  
}